import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { editVillageDetails } from "../../actions/area";
import Spinner from "../layout/Spinner";

const EditVillageDetails = ({
  setShowUpdateModal,
  savedMessage,
  auth: { isAuthenticated, user, users, loading },
  villages,
  editVillageDetails,
}) => {
  //formData
  const [formData, setFormData] = useState({
    villageName: villages && villages.villageName ? villages.villageName : "",

    isSubmitted: false,
  });
  const { villageName } = formData;

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onUpdate = (e) => {
    e.preventDefault();
    const finalData = {
      recordId: villages ? villages._id : "",
      villageName: villageName,
      villageEnteredById: user._id,
      villageEnteredByName: user.userName,
      institutionId: user.institutionId,
    };

    editVillageDetails(finalData);
    setShowUpdateModal(false);
  };

  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      <div className="container container_align">
        <form className="row" onSubmit={(e) => onUpdate(e)}>
          <div className="row col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="col-lg-10 col-md-12 col-sm-12 col-12">
              <label className="label-control"> Village Name* :</label>
              <input
                type="text"
                name="villageName"
                value={villageName}
                className="form-control"
                onChange={(e) => onInputChange(e)}
                required
              />
            </div>
          </div>

          <div className="col-md-10 col-lg-10 col-sm-12 col-12 text-left">
            {loading ? (
              <button
                className="btn sub_form btn_continue Save float-right"
                disabled
              >
                Loading...
              </button>
            ) : (
              <input
                type="submit"
                name="Submit"
                value="Update"
                className="btn sub_form btn_continue Save float-right"
              />
            )}
          </div>
        </form>
      </div>
    </Fragment>
  );
};

EditVillageDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  editVillageDetails: PropTypes.func.isRequired,
  savedMessage: PropTypes.string,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  area: state.area,
  savedMessage: state.auth.savedMessage,
});

export default connect(mapStateToProps, {
  editVillageDetails,
})(EditVillageDetails);
